import { useQuery } from '@tanstack/react-query';
import { PractitionerOpening, PractitionersApi } from '~/api';
import { getBaseUrl } from '~/env';
import { ErrorLevel, logErrorToSentry } from '~/utilities';

export function usePractitionerOpenings(
  staffMemberGuid: string,
  locationId: number
) {
  const queryResults = useQuery<PractitionerOpening[]>({
    queryKey: ['openings', staffMemberGuid, locationId],
    queryFn: async () => {
      const api = new PractitionersApi({ baseUrl: getBaseUrl() });
      const response = await api.getOpenings(staffMemberGuid, locationId);
      const data = await response.json();
      return data.openings || [];
    },
    // If set to a function, it will be passed the error and the query,
    // and it should return a boolean indicating whether to show the
    // error in an error boundary (`true`) or return the error as state (`false`).
    throwOnError(error, _query) {
      logErrorToSentry({ type: ErrorLevel.Error, message: error.message });
      return false;
    },
  });

  return {
    openings: queryResults.data || [],
    isLoading: queryResults.isLoading,
    isError: queryResults.isError,
    error: queryResults.error,
  };
}
